// Produktové karty — texty tlačítek, přesun slevových flagů, zkrácené dostupnosti.
// Jediný vstupní bod pro všechna místa, kde Shoptet vykresluje .product karty
// (kategorie, vyhledávání, homepage slidery, detail, pop-up po přidání do košíku,
// AJAX stránkování / filtry / načíst další).

// Dostupnosti, které se zkracují. Detail produktu (.type-detail .availability-value)
// a řádky košíku (tr.removeable .availability-label) tu vědomě NEJSOU — tam se
// zobrazuje celý text z administrace.
const AVAILABILITY_SELECTORS = [
    ".product .availability > .show-tooltip",
    ".cart-related-availability",
    ".advanced-order .extras-wrap .availability-label",
    ".advanced-order .extras-wrap .availability",
].join(", ");

// scope může být jQuery objekt, DOM element i selektor; default celý dokument
function resolveScope(scope) {
    if (!scope) {
        return $(document);
    }
    return scope instanceof $ ? scope : $(scope);
}

// Vrátí prvky ze selektoru uvnitř scope i samotný scope, pokud selektoru odpovídá
function findInScope($scope, selector) {
    return $scope.find(selector).add($scope.filter(selector));
}

// Zkrátí text textového uzlu na část před separátorem.
// Pracuje s textovými uzly, aby zůstaly vnořené prvky (.availability-amount) i atributy
// (data-original-title, style="color:…") beze změny.
function shortenTextNodes(element, separator) {
    const childNodes = element.childNodes;

    for (let i = 0; i < childNodes.length; i++) {
        const node = childNodes[i];

        if (node.nodeType === 3) {
            const index = node.nodeValue.indexOf(separator);
            // Separátor v textu není → text je už krátký, nic neměníme (idempotence)
            if (index !== -1) {
                node.nodeValue = node.nodeValue.slice(0, index).trim();
            }
            continue;
        }

        // Množství "(29 ks)" se nikdy nezkracuje
        if (node.nodeType === 1 && !$(node).hasClass("availability-amount")) {
            shortenTextNodes(node, separator);
        }
    }
}

window.shortenAvailability = function (scope) {
    const separator = window.shopDataLayer && window.shopDataLayer.availability
        ? window.shopDataLayer.availability.shortSeparator
        : null;
    if (!separator) {
        return;
    }

    findInScope(resolveScope(scope), AVAILABILITY_SELECTORS).each(function () {
        shortenTextNodes(this, separator);
    });
};

window.initProductCards = function (scope) {
    const $scope = resolveScope(scope);

    findInScope($scope, ".product .p-tools .btn-primary").html(window.shopDataLayer.product.detailButton);
    findInScope($scope, ".product .p-tools .add-to-cart-button").html(window.shopDataLayer.product.addToCartButton);

    // Přesun slevových flagů — po přesunu už prvky nejsou v .flag-discount,
    // takže druhé volání nic nezdvojí
    findInScope($scope, ".product").each(function () {
        const $product = $(this);

        $product.find(".flag-discount .price-standard").prependTo($product.find(".p-bottom .prices"));
        if ($product.find(".flags-default").length === 0) {
            $("<div class='flags-default'></div>").appendTo($product.find(".image"));
        }
        $product.find(".flag-discount .price-save").addClass("flag flag-save").appendTo($product.find(".flags-default"));
    });

    window.shortenAvailability($scope);
};

$(document).ready(function () {
    window.initProductCards();
});

const productCardEvents = [
    "ShoptetDOMContentLoaded",
    "ShoptetDOMPageContentLoaded",
    "ShoptetDOMPageMoreProductsLoaded",
    "ShoptetDOMSearchResultsLoaded",
    "ShoptetDOMCartContentLoaded",
];

productCardEvents.forEach(function (eventName) {
    document.addEventListener(eventName, function () {
        window.initProductCards();
    });
});

// Pop-up po přidání do košíku je v DOM až při tomto eventu (ShoptetDOMContentLoaded firne dřív)
document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    window.initProductCards(".advanced-order");
});
